import { storageService } from "@twiage/core";

import type { ToggleableGlobalOptions } from "../../types/ToggleableGlobalOptions";
import type { ToggleUseScrollFieldsOnly } from "../../types/ToggleUseScrollFieldsOnly";

export const toggleUseScrollFieldsOnly: ToggleUseScrollFieldsOnly = ({
  state,
}) => {
  state.toggleableGlobalOptions.useScrollFieldsOnly =
    !state.toggleableGlobalOptions.useScrollFieldsOnly;

  const toggleableGlobalOptions =
    storageService.getItemAsObject<ToggleableGlobalOptions>(
      "toggleableGlobalOptions",
    );

  if (toggleableGlobalOptions) {
    toggleableGlobalOptions.useScrollFieldsOnly =
      state.toggleableGlobalOptions.useScrollFieldsOnly;

    storageService.save("toggleableGlobalOptions", toggleableGlobalOptions);
  }
};
